module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("25r1x"))).then(() => parcelRequire('iDabs'));